import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"
import {H5} from "@irati/ui/src/Typography"

interface ContainerProps {
  completed?: boolean
}

export const Container = styled(Flex)<ContainerProps>`
  background-color: ${({theme, completed}) => (completed ? theme.colors.utility.highlight : theme.colors.greys.lightest)};
  border-radius: ${({theme}) => theme.spacing.one};
`
export const FlexItem = styled(H5)`
  align-self: center;
`
export const SliderContainer = styled(Flex)`
  height: 100%;
  .slick-slider {
    width: 85%;
    display: inline-grid;
    top: -${({theme}) => theme.spacing.four};
  }
`
